const eventInitialState={
    events:[],
    isFetching: false,
    isSaving:false,
    saveError: null,
    saveSuccess:null
 };

const eventReducer=(state=eventInitialState,action)=>{
    switch(action.type){
        case 'GET_ALL_EVENTS_START':
            return {
                ...state,
                isFetching: true,
              };
        case 'GET_ALL_EVENTS_SUCCESS':
            return {
                ...state,
                isFetching: false,
                events: action.payload,
              };
        case 'GET_ALL_EVENTS_FAILURE':
            return {
                ...state,
                isFetching: false,
                saveError: action.payload,
              };
        default:
            return state;
    }
}

export default eventReducer;